<template src="./SearchEngine.html"></template>

<script>
    import { createNamespacedHelpers } from 'vuex'
    import sitesTopMenu from "@/components/sites/components/topMenu";
    import Pagination from "@/components/components/pagination";
    import yandexRegion from "@/components/sites/searchEngine/components/yandexRegion/SearchEngine";
    import googleRegion from "@/components/sites/searchEngine/components/googleRegion/SearchEngine";

    const { mapGetters, mapActions} = createNamespacedHelpers('sites/sites')

    export default {
        name: "Task",
        components: {
          sitesTopMenu,
          Pagination,
          yandexRegion,
          googleRegion
        },
        data () {
            return {
            }
        },
        methods: {
        },
        computed: {
          ...mapGetters([
            'SITES_DATA',
          ]),
          firstSiteId: function () {
            return this.SITES_DATA[0]?.id?.toString() ?? '';
          },
        },
        mounted() {
          if (this.$store.getters.getAllowSection.indexOf('sites') === -1) {
            this.$router.push({name: 'permissionDenied'});
            return;
          }
        },
    }
</script>

<style scoped>

</style>

<style>

</style>